<span #tooltipTag class="more_info"> </span>
<ng-content></ng-content>
